// ./src/components/generic/form/SwitchField.tsx
//
// Switch wrapper on the shared `(name, value)` change contract. Emits the
// boolean checked state.

import React from 'react';
import { Switch, SwitchProps } from '@mantine/core';

import { FieldChangeHandler } from './types';

export interface SwitchFieldProps extends Omit<SwitchProps, 'onChange'> {
  name?: string;
  onChange?: FieldChangeHandler<boolean>;
}

export const SwitchField: React.FC<SwitchFieldProps> = ({ name, onChange, ...rest }) => (
  <Switch onChange={(e) => onChange?.(name, e.currentTarget.checked)} {...rest} />
);
